import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { getWarehouseStoreById } from "../../../services/warehouse/WarehouseWithStore";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";
import WarehouseStoreStatusChange from "./WarehouseStoreStatusChange";
import WarehouseStoreAddModal from "./WarehouseStoreAddModal";
import AdminMenu from "../../AdminMenu";


const WarehouseConfigStores = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [storeUserList, setStoreUserList] = useState([]);
  const [warehouseStoreData, setWarehouseStoreData] = useState([]);

  const [warehouseStoreAddModalVisible, setWarehouseStoreAddModalVisible] =
    useState(false);

  
  const [loadingStore, setLoadingStore] = useState(false);


  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;

  const fetchData = () => {
    // getWarehouseStore(brandId)
    setLoadingStore(true);
    getWarehouseStoreById(id)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          setWarehouseStoreData(Res);
          setLoadingStore(false);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });

    getBrandStore(brandId)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreUserList(Res);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });

     
  };

 

  useEffect(() => {
    fetchData();
  }, []);

  const receiveDataFromBrandWarehouseStoreUserStatusChange = ({success}) => {
    if (success) {
      fetchData();
    }
  };
  const renderWarehouseStoreCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Store :
                  </p>
                  <p className="text-lg font-medium capitalize">
                  {storeUserList.find(
                        storeItem => storeItem.id === item.storeId,
                      )?.storeName || ''}
                  </p>
                </div>
                 
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    <p className="text-lg font-medium capitalize">{item.status === true ? 'Active' : 'DeActive'}{' '}</p>
                  </div>
                  <WarehouseStoreStatusChange
                      status={item.status}
                      sendDataToWarehouseConfig={
                        receiveDataFromBrandWarehouseStoreUserStatusChange
                      }
                      editData={item}
                      brandId={brandId}
                      warehouseId={id}
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/WarehouseManagementList", {
                      state: {
                        id: id,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Warehouse Config
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
            onClick={() => {
              setWarehouseStoreAddModalVisible(true);
            }}
          >
            <img src="images/plus.png" alt="plus" style={{width:30}}/>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loadingStore ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : warehouseStoreData?.length > 0 ? (
          <div>
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">MAPPED STORE</p>
              </div>
              </div>
              </div>

            <div>{renderWarehouseStoreCardItem(warehouseStoreData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Warehouse Data Present</p>
          </div>
        )}
      </div>
      <WarehouseStoreAddModal
          warehouseStoreAddModalVisible={warehouseStoreAddModalVisible}
          setWarehouseStoreAddModalVisible={setWarehouseStoreAddModalVisible}
          sendDataToWarehouseConfig={
            receiveDataFromBrandWarehouseStoreUserStatusChange
          }
          brandId={brandId}
          storeUserList={storeUserList}
          warehouseId={id}
        warehouseStoreData={warehouseStoreData}
        />

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default WarehouseConfigStores;
